<template>
  <div>
    <v-layout style="align-items: center" class="mt-4">
      <v-flex>
        <h1 class="headline">Theme</h1>
      </v-flex>
      <v-flex class="text-xs-right">
        <v-btn v-if="!isEdit" icon color="primary" outline @click="isEdit = true">
          <v-icon>edit</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <ThemeConfigManage
      v-if="isEdit"
      @onChangeConfig="handleChangeThemeConfig"
      @onCancel="isEdit = false"
    />
    <template v-else>
      <v-layout class="my-3">
        <v-flex xs12 sm6> Theme </v-flex>
        <v-flex xs12 sm6 class="text-xs-right">
          {{ selectedBot.theme }}
        </v-flex>
      </v-layout>
    </template>
  </div>
</template>

<script>
import ThemeConfigManage from './ThemeConfigManage.vue'
import { mapGetters } from 'vuex'
import pageConfigApi from '@/api/page-config'
import { handleApiError } from '@/api/util'
export default {
  components: {
    ThemeConfigManage
  },
  data() {
    return {
      isEdit: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  methods: {
    async handleChangeThemeConfig(data) {
      try {
        const input = {
          theme: data,
          page_id: this.selectedBot.pageid
        }
        const response = await pageConfigApi.postThemeConfig({
          data: input
        })
        if (response.status == 200 || response.status == 204) {
          const currentBot = {
            ...this.selectedBot,
            theme: data
          }

          const newbotlist = this.$store.state.botlist
          const botIndex = newbotlist.findIndex((oldbot) => {
            return this.selectedBot.pageid == oldbot.pageid
          })
          if (newbotlist) {
            newbotlist[botIndex] = currentBot
            this.$store.dispatch('updateBotlist', newbotlist)
          }

          this.$store.dispatch('selectBot', currentBot)
          await this.$swal.fire({
            title: this.$t('Successfully'),
            type: 'success'
          })
        }
      } catch (error) {
        await handleApiError(error)
      } finally {
        this.isEdit = false
        window.location.reload()
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/AdvancedSetting/ThemeConfig.vue